"use client";

import type { OrganizationWallet } from "@/types/wallet";
import type { InlineBadgeVariant } from "./shared-badge-styles";
import type { ReactNode } from "react";
import { parseTextWithAddresses, type InlineTokenData } from "./workflow-step-row/components/InlineAddressLink";

export function renderTextWithOrganizationWallets(
  text: string,
  wallets: OrganizationWallet[],
  tokensMap?: Map<string, InlineTokenData>,
  variant: InlineBadgeVariant = "summary",
): ReactNode[] {
  return parseTextWithAddresses(text, tokensMap, wallets, variant);
}
